import React from 'react';
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux';
import reducer from '../General/Reducers';
import Network from '../Utils/network';
import thunk from 'redux-thunk';
import SplashScreenComponent from './CommonPage/SplashScreen';
var store;
var allLocales = { locales: {} };

export default class IndexPageComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillMount() {
        if (process.env.NODE_ENV == 'production') { console.log('Looks like we are in >> production mode!'); }
        else { console.log('Looks like we are in >> development mode!'); }
        var doc = document.documentElement;
        var userAgent = navigator.userAgent
        doc.setAttribute('data-useragent', userAgent);
        if (userAgent.indexOf('Windows') > -1) {
            document.body.classList.add('add-gotham-font');
            document.body.classList.remove('add-normal-font');
        } else {
            document.body.classList.add('add-normal-font');
            document.body.classList.remove('add-gotham-font');
        }
        //localStorage.setItem("uniqueToken", "")
        try {
            var getAllLocalesResponse = Network.executeSyncRequest('GET', '/getAllLocales');
            allLocales.locales = JSON.parse(getAllLocalesResponse.getBody());
        } catch (err) {
            allLocales.locales = {};
        }
        store = createStore(reducer, allLocales, applyMiddleware(thunk));
    };
    render() {
        return (
            <Provider store={store}>
                <SplashScreenComponent />
            </Provider>
        );
    }
}
